import styled from "styled-components";

export const LastUpdateTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  cursor: default;
  line-height: 0;
`;

export const LastUpdateTooltip = styled.div`
  position: fixed;
  transform: translate(-100%, -50%);
  min-width: 250px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #6d6d6d;
  color: var(--color-contrast-white);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  white-space: nowrap;
  z-index: 100000;
  pointer-events: none;
  font-size: 18px;
  font-weight: var(--font-weight-regular);
`;
